import _ from 'lodash';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import { Form, Icon } from 'semantic-ui-react';
import { apiHandlers, apiInitialState, apiReducer } from '../../../global/cnr/reducers/ApiReducer';
import GenericButton from '../../../global/genericControls/GenericButton';
import Wrapper from '../../../global/wrappers/Wrapper';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import GolfCourse from './GolfCourse';
import { scorecardTypes } from './Scorecard';
import { fsUpdate_subCollection } from '../../../global/firestoreData/updates/subUpdates/fsUpdate_addData';
import { ParentContext } from 'global/cnr/contexts/ParentContext';

const GolfCourseFetch = (props) => {

  let { caption, allowedUrl } = props

  const parentContext = useContext(ParentContext);
  const { fn_cls } = parentContext ?? {}

  // golfParentContext  
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states, handlers, fns } = golfParent_contexts ?? {}
  const { paps_state } = states ?? {}
  const { item_handlers } = handlers ?? {}
  const { page_fns, database_fns } = fns ?? {}

  // papsContext 
  const { pathViews } = paps_state ?? {}

  // paps_state, viewItem, viewListData, page_fns
  const [api_state, api_dispatch] = useReducer(apiReducer, apiInitialState(paps_state, props.viewItem, props.viewListData, page_fns));
  const api_handlers = apiHandlers(api_dispatch)
  const { apiResult: golfCourse } = api_state ? api_state : {}

  if (!caption) { caption = 'Paste' }
  caption = _.startCase(caption)

  const [updating, setUpdating] = useState()
  const [url, setUrl] = useState(allowedUrl)
  const [currentGolfCourse, setCurrentGolfCourse] = useState()

  useEffect(() => {
    if (golfCourse) {
      const { teeBoxes, holes } = golfCourse ?? {}
      if (teeBoxes && teeBoxes.pos4) {
        teeBoxes.position4 = teeBoxes.pos4
        delete teeBoxes.pos4
      }
      if (holes) {
        _.forEach(holes, (hole) => {
          if (hole.pos4) {
            hole.position4 = hole.pos4
            delete hole.pos4
          }
        })
      }
      setCurrentGolfCourse(golfCourse)
    }
  }, [golfCourse]);

  const handleSaveGolfCourse = () => {
    const cb = (res) => {
      setUpdating(false)
    }
    setUpdating(true)
    fsUpdate_subCollection(database_fns, pathViews, {}, 'golfCourses', currentGolfCourse, cb)
  }

  const handleUrlSearch = () => fn_cls.handleGolfCourseSearch(fn_cls, url)
  // const handleGhinSearch = () => api_handlers.handleGhinSearch()
  const handleUrlChange = (e, data) => { setUrl(data.value) }

  const input = () => (
    <Form>
      <Form.Input
        icon={<Icon name='search' inverted circular link onClick={handleUrlSearch} />}
        value={url} label='Url' placeholder={'url'} onChange={handleUrlChange}
      />
    </Form>
  )

  const gb = (key, caption, icon, onClick, clickOptions, opts, noE) => <GenericButton gbProps={{ key, caption, icon, onClick, clickOptions, opts, noE }} />

  const content = () => {
    return <div className={'paste-container'}>
      <div className={'paste-content'}>
        {currentGolfCourse && <GolfCourse golfCourse={currentGolfCourse} scorecardType={scorecardTypes.normal} />}
      </div>
    </div>
  }

  const footer = () => <React.Fragment>
    {gb('btn-cancel', 'Cancel', 'delete', item_handlers && item_handlers.handleShow_itemSidebar, null, { color: 'grey' })}
    {gb('btn-save', 'Save', 'save', handleSaveGolfCourse, null, { disabled: !currentGolfCourse })}
  </React.Fragment>

  return <Wrapper
    header={input()}
    content={content()}
    footer={footer()}
    updating={updating}
    css={{ header: 'padd5', footer: 'padd5 modify' }}
  />
}

export default GolfCourseFetch